module.exports = __webpack_public_path__ + "media/images/iceland.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/iceland.jpg
// module id = 71
// module chunks = 0